module.exports = __webpack_public_path__ + "ov_2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/contact/ov/ov_2.jpg
// module id = 873
// module chunks = 0